// ./components/encuestas/ModalEncuesta.jsx
import React from "react";
import styled from "styled-components";

const Backdrop = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background-color: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  width: 70%;
  height: 70%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 0 15px rgba(0,0,0,0.3);

  /* En móvil se adapta */
  @media (max-width: 768px) {
    width: 90%;
    height: auto;
    max-height: 90vh;
    overflow-y: auto;
  }
`;

const CloseButton = styled.button`
  background: #cc0000;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  margin-top: 1rem;
  border-radius: 4px;
  cursor: pointer;
  align-self: flex-end;
`;

const ModalEncuesta = ({ onClose, children }) => (
  <Backdrop>
    <ModalContent>
      {children}
      <CloseButton onClick={onClose}>Cerrar</CloseButton>
    </ModalContent>
  </Backdrop>
);

export default ModalEncuesta;
